import moment from "moment";

/**
 * Form values may be a Moment, unix seconds (~1e9), or milliseconds (~1e12).
 * `moment(number)` always treats numbers as ms, which breaks unix seconds.
 * API payloads use unix seconds.
 */
export function workoutDateToUnixSeconds(value) {
  if (value == null) return moment().unix();
  if (moment.isMoment(value)) return value.unix();
  if (typeof value === "number" && Number.isFinite(value)) {
    if (value > 1e12) return Math.floor(value / 1000);
    return Math.floor(value);
  }
  return moment(value).unix();
}

/** Display a stored workout date (unix seconds, ms, Moment, or parseable string). */
export function momentFromWorkoutTimestamp(value) {
  if (value == null) return moment();
  if (moment.isMoment(value)) return value.clone();
  if (typeof value === "number" && Number.isFinite(value)) {
    if (value > 1e12) return moment(value);
    return moment.unix(value);
  }
  return moment(value);
}
